<template>
  <div>
    <!-- Editar Expediente -->
    <v-card v-if="probar" class="hide-overflow">
      <v-toolbar card>
        <v-icon>create</v-icon>
        <v-toolbar-title class="font-weight-light"
          >Edición expediente
          {{ expteId(expedienteSelected.idx) }}</v-toolbar-title
        >
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="expteFilteredDialog" max-width="500px">
          <v-btn slot="activator" color="primary" dark class="mb-2"
            >Filtros</v-btn
          >
          <v-card>
            <v-card-title>
              <div>
                <div class="headline">Configurar Filtros</div>
                <span class="grey--text"
                  >{{
                    catastroSelected.inmuebles ? catastroFilter.length : "0"
                  }}
                  Registros coincidentes</span
                >
              </div>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-combobox
                      v-model="catastroFilterOption.uso"
                      :items="inmueblesFiltersUso"
                      label="Uso inmueble"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-if="inmueblesFiltersPropietario.length > 1"
                      v-model="catastroFilterOption.propietario"
                      :items="inmueblesFiltersPropietarioNamed"
                      item-text="name"
                      label="Propietario"
                      multiple
                    >
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                flat
                @click.native="expteFilteredDialog = false"
                >Cerrar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-btn
          fab
          dark
          small
          :color="catastroFilteredList ? 'success' : 'secundary'"
          @click="catastroFilteredList = !catastroFilteredList"
          ><v-icon>filter_list</v-icon></v-btn
        >
        <v-spacer></v-spacer>
        <v-btn-toggle v-model="catastroControl.tableOption" mandatory>
          <v-btn flat>
            <v-icon>view_list</v-icon>
          </v-btn>
          <v-btn flat>
            <v-icon>view_headline</v-icon>
          </v-btn>
          <v-btn flat>
            <v-icon>view_module</v-icon>
          </v-btn>
        </v-btn-toggle>
        <v-btn
          color="blue-grey darken-3"
          fab
          small
          @click="expedienteProfile.isEditing = !expedienteProfile.isEditing"
        >
          <v-icon v-if="expedienteProfile.isEditing" color="white"
            >close</v-icon
          >
          <v-icon v-else color="white">create</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <template>
              <v-flex xs6 sm4 md4>
                <v-text-field
                  disabled
                  label="Referencia Catastral"
                  v-model="expedienteSelected.detalle.refCatastro"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm8 md8 class="text-xs-right grey--text">
                <span>{{
                  direccionCatastro(catastroSelected.datos).direc1
                }}</span
                ><br />
                <span>{{
                  direccionCatastro(catastroSelected.datos).direc2
                }}</span
                ><br />
                <span
                  >({{
                    catastroSelected.inmuebles
                      ? catastroSelected.inmuebles.length
                      : "0"
                  }}
                  Inmuebles)</span
                >
              </v-flex>
              <v-divider></v-divider>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  :disabled="!expedienteProfile.isEditing"
                  :prepend-icon="
                    expedienteSelected.detalle.admon ? 'person' : 'add_circle'
                  "
                  @click:prepend="
                    expteEditUser(
                      expedienteSelected.detalle.admon,
                      'adminfincas'
                    )
                  "
                  v-model="expedienteSelected.detalle.admon"
                  :items="adminfincas"
                  item-text="name"
                  item-value="idx"
                  label="Administrador de Fincas"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  :disabled="!expedienteProfile.isEditing"
                  :prepend-icon="
                    expedienteSelected.detalle.gestor ? 'person' : 'add_circle'
                  "
                  @click:prepend="
                    expteEditUser(expedienteSelected.detalle.gestor, 'gestores')
                  "
                  v-model="expedienteSelected.detalle.gestor"
                  :items="gestores"
                  item-text="name"
                  item-value="idx"
                  label="Gestor Responsable"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-autocomplete
                  :disabled="!expedienteProfile.isEditing"
                  v-model="expedienteSelected.detalle.status"
                  :items="expteStatus"
                  label="Estado Expediente"
                  persistent-hint
                >
                </v-autocomplete>
              </v-flex>
              <!-- tabla inmuebles -->
              <v-flex xs12 v-if="catastroControl.tableOption === 0">
                <v-data-table
                  rows-per-page-text="Resultados por página"
                  :headers="catastroControl.headers"
                  :items="catastroFilter"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      {{ props.item.car }}{{ props.item.cc1
                      }}{{ props.item.cc2 }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.dir_int_bloque || "-" }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.dir_int_escalera || "-" }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.dir_int_planta || "-" }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.dir_int_puerta || "-" }}
                    </td>
                    <td class="text-xs-right">
                      {{ formatNumber2Dec(props.item.participacion, 2) }}
                    </td>
                    <td
                      class="text-xs-center"
                      v-if="props.item.propietario"
                      :disabled="!expedienteProfile.isEditing"
                    >
                      {{ userUid2Name(props.item.propietario) }}
                      <a
                        class="btn btn-outline-primary btn-sm no-decoration"
                        style="padding-left: 7px;"
                        role="button"
                        @click="expteEditUser(props.item.propietario)"
                      >
                        <v-icon small class="mr-2" color="primary"
                          >create</v-icon
                        >
                      </a>
                    </td>
                    <td class="text-xs-center" v-else>
                      <v-btn
                        :disabled="!expedienteProfile.isEditing"
                        slot="activator"
                        color="primary"
                        small
                        dark
                        @click="
                          asignarUserCatastro(
                            expedienteSelected.detalle.refCatastro,
                            props.item.car
                          )
                        "
                      >
                        Asignar
                      </v-btn>
                    </td>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" color="info" icon="info">
                      No existen documentos :(
                    </v-alert>
                  </template>
                </v-data-table>
              </v-flex>
              <!-- tabla inmuebles Pre-registro usuarios -->
              <v-flex xs12 v-if="catastroControl.tableOption === 1">
                <v-data-table
                  rows-per-page-text="Resultados por página"
                  :headers="catastroControl.headersPre"
                  :items="catastroFilterPre"
                  class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-xs-center">
                      {{ props.item.car }}{{ props.item.cc1
                      }}{{ props.item.cc2 }}
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.dir_int_bloque || "-" }} /
                      {{ props.item.dir_int_escalera || "-" }} /
                      {{ props.item.dir_int_planta || "-" }} /
                      {{ props.item.dir_int_puerta || "-" }}
                    </td>
                    <!-- <td class="text-xs-center">{{ props.item.dir_int_escalera || '-' }}</td>
                                        <td class="text-xs-center">{{ props.item.dir_int_planta || '-' }}</td>
                                        <td class="text-xs-center">{{ props.item.dir_int_puerta || '-' }}</td> -->
                    <template v-if="props.item.preUserSaved">
                      <td
                        class="text-xs-center"
                        :disabled="!expedienteProfile.isEditing"
                      >
                        {{ props.item.preUserName }}
                      </td>
                      <td
                        class="text-xs-center"
                        :disabled="!expedienteProfile.isEditing"
                      >
                        {{ props.item.preUserTlf }}
                      </td>
                      <td class="text-xs-center">
                        <a
                          class="btn btn-outline-primary btn-sm no-decoration"
                          style="padding-left: 7px;"
                          role="button"
                          @click="expteEditUser(props.item.propietario)"
                        >
                          <v-icon small class="mr-2" color="primary"
                            >create</v-icon
                          >
                        </a>
                      </td>
                    </template>
                    <!-- pre-registrar usuario -->
                    <template v-else>
                      <td class="text-xs-center">
                        <v-text-field
                          v-model="props.item.preUserName"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-center">
                        <v-text-field
                          v-model="props.item.preUserTlf"
                        ></v-text-field>
                      </td>
                      <td class="text-xs-center">
                        <a
                          class="btn btn-outline-primary btn-sm no-decoration"
                          style="padding-left: 7px;"
                          role="button"
                          @click="preUserNew(props.item)"
                        >
                          <v-icon small class="mr-2" color="primary"
                            >sms</v-icon
                          >
                        </a>
                      </td>
                    </template>
                  </template>
                  <template slot="no-data">
                    <v-alert :value="true" color="info" icon="info">
                      No existen documentos :(
                    </v-alert>
                  </template>
                </v-data-table>
              </v-flex>
              <!-- detalle inmuebles -->
              <v-flex xs12 v-if="catastroControl.tableOption === 2">
                <v-data-iterator
                  rows-per-page-text="Resultados por página"
                  :items="catastroFilter"
                  :rows-per-page-items="
                    catastroControl.fichaOptions.rowsPerPageItems
                  "
                  :pagination.sync="catastroControl.fichaOptions.pagination"
                  content-tag="v-layout"
                  row
                  wrap
                >
                  <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
                    <v-card>
                      <v-card-title class="align-center"
                        ><h4>
                          {{ expedienteSelected.detalle.refCatastro
                          }}{{ props.item.car }}{{ props.item.cc1
                          }}{{ props.item.cc2 }}
                        </h4></v-card-title
                      >
                      <v-divider></v-divider>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content>Bloque:</v-list-tile-content>
                          <v-list-tile-content class="align-end">{{
                            props.item.dir_int_bloque || "-"
                          }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Escalera:</v-list-tile-content>
                          <v-list-tile-content class="align-end">{{
                            props.item.dir_int_escalera || "-"
                          }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Planta:</v-list-tile-content>
                          <v-list-tile-content class="align-end">{{
                            props.item.dir_int_planta || "-"
                          }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Puerta:</v-list-tile-content>
                          <v-list-tile-content class="align-end">{{
                            props.item.dir_int_puerta || "-"
                          }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Uso:</v-list-tile-content>
                          <v-list-tile-content class="align-end">{{
                            props.item.uso || "-"
                          }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Superficie:</v-list-tile-content>
                          <v-list-tile-content class="align-end"
                            >{{
                              props.item.superficie || "-"
                            }}
                            m2</v-list-tile-content
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content>Cuota P.:</v-list-tile-content>
                          <v-list-tile-content class="align-end"
                            >{{
                              formatNumber2Dec(props.item.participacion, 2) ||
                                "-"
                            }}
                            %</v-list-tile-content
                          >
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content
                            >Propietario:</v-list-tile-content
                          >
                          <v-list-tile-content
                            class="align-end"
                            v-if="props.item.propietario"
                          >
                            {{ userUid2Name(props.item.propietario) }}
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end" v-else>
                            <v-btn
                              :disabled="!expedienteProfile.isEditing"
                              slot="activator"
                              color="primary"
                              small
                              dark
                              @click="
                                asignarUserCatastro(
                                  expedienteSelected.detalle.refCatastro,
                                  props.item.car
                                )
                              "
                            >
                              Asignar
                            </v-btn>
                          </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile v-if="props.item.propietario">
                          <v-list-tile-content class="align-center">
                            <v-btn
                              color="primary"
                              small
                              dark
                              @click="expteEditUser(props.item.propietario)"
                            >
                              <v-icon small class="mr-2">create</v-icon> Editar
                              Propietario
                            </v-btn>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </v-data-iterator>
              </v-flex>
            </template>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <span class="grey--text"
          >Expediente: {{ expteId(expedienteSelected.idx) }}</span
        >
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!expedienteProfile.isEditing"
          color="success"
          @click="expedienteSave"
        >
          Guardar
        </v-btn>
        <v-btn
          :disabled="!expedienteProfile.isEditing"
          color="danger"
          @click="expedienteReset"
        >
          Cancelar
        </v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-else>
      <pre>{{ $route.params.id }}</pre>
      <pre>{{ $store.getters.getExpedienteSelected($route.params.id) }}</pre>
    </v-card>
  </div>
</template>

<script>
// import Profile from "./profile";
import { mapState, mapGetters, mapActions } from "vuex";
export default {
  name: "ExpedientesEdit",
  // props: ['uid'],
  components: {
    // Profile
  },
  data() {
    return {
      probar: true,
      bottomNav: 0,
      expedienteSelected: false,
      expteFilteredDialog: false,
      catastroSelected: false,
      catastroFilteredList: true,
      catastroFilterOption: {
        uso: [],
        propietario: []
      },
      catastroControl: {
        headers: [
          { text: "#", align: "center", value: "car", sortable: true },
          {
            text: "BL",
            align: "center",
            value: "dir_int_bloque",
            sortable: true
          },
          {
            text: "ESC",
            align: "center",
            value: "dir_int_escalera",
            sortable: true
          },
          {
            text: "PLTA",
            align: "center",
            value: "dir_int_planta",
            sortable: true
          },
          {
            text: "PUERTA",
            align: "center",
            value: "dir_int_puerta",
            sortable: true
          },
          { text: "%", align: "right", value: "participacion", sortable: true },
          {
            text: "Popietario",
            align: "center",
            value: "propietario",
            sortable: true
          }
        ],
        headersPre: [
          { text: "#", align: "center", value: "car", sortable: true },
          {
            text: "BL/ESC/PLTA/PUERTA",
            align: "center",
            value: "",
            sortable: false
          },
          {
            text: "Pre-Registro",
            align: "center",
            value: "preUserName",
            sortable: true
          },
          { text: "Tlf", align: "center", value: "telefono", sortable: true },
          { text: "Acción", align: "center", value: "", sortable: false }
        ],
        tableOption: 0,
        fichaOptions: {
          rowsPerPageItems: [4, 8, 12],
          pagination: {
            rowsPerPage: 4
          }
        }
      },
      expedienteProfile: {
        hasSaved: false,
        isEditing: null,
        model: null
      },
      searchCatastro: "",
      enabledSearchCatastro: false,
      searchingCatastro: "",
      guardando: false
    };
  },
  watch: {
    searchCatastro(ahora) {
      this.searchingCatastro = "";
      if (ahora !== "") {
        let length = ahora.length;
        if (length === 14) {
          // consoleLog(`Buscar Catastro: ${ahora}`)
          this.searchingCatastro = `...buscando ${ahora}`;
          this.getResultCatastro();
        }
      }
    }
  },
  created() {
    this.seleccionarExpte();
  },
  mounted: function() {
    this.$emit("changeBottomNav", 1);
  },
  methods: {
    ...mapActions(["setCatastro"]),
    expedienteReset() {
      // consoleLog('Cancelar edición expediente')
    },
    seleccionarExpte() {
      const idx = this.$route.params.id;
      this.expedienteSelected = this.$store.getters.getExpedienteSelected(idx);
      // this.expedienteSelected = JSON.parse(localStorage._GA_expteSelec)
      let refCatastro = this.expedienteSelected.detalle.refCatastro || false;
      if (refCatastro) {
        this.catastroCarga(refCatastro);
      }
    },
    prueba() {
      // Esto es una prueba
    },
    setUsers() {
      this.$store.dispatch("setUsers");
    },
    setUsersPreReg() {
      this.$store.dispatch("setUsersPreReg");
    },
    setExpedientes() {
      this.$store.dispatch("setExpedientes");
    },
    setExpedientesStatus() {
      this.$store.dispatch("setExpedientesStatus");
    },
    setCatastro() {
      this.$store.dispatch("setCatastro");
    },
    setMunicipios(data) {
      this.$store.dispatch("setMunicipios", data);
    },
    setProvincias() {
      this.$store.dispatch("setProvincias");
    },
    updateExpedientes(data) {
      this.$store.dispatch("updateExpedientes", data);
    },
    preUserNew(item) {
      // eslint-disable-next-line
            // console.log('Actualizado el index: ',index)
      const tlf = item.preUserTlf;
      // const nombre = item.preUserName
      let nombre = item.preUserName;
      if (nombre.length < 2) {
        return alert(`El Nombre introducido no es correcto ${nombre}`);
      }
      const patronTlf = /^[6][0-9]{8}$/;
      if (!patronTlf.test(tlf)) {
        return alert(`El teléfono introducido no es correcto ${tlf}`);
      }
      nombre = nombre
        .toLowerCase()
        .split(" ")
        .map(s => s.charAt(0).toUpperCase() + s.substring(1))
        .join(" ");
      const result = {
        expte: this.expedienteSelected.idx,
        ref: this.expedienteSelected.detalle.refCatastro,
        inmu: item.car,
        nombre: nombre,
        tlf: tlf
      };
      // 1 - Comprobar que el número de tlf no existe previamente en la bbdd
      if (this.usersPreReg[tlf]) {
        return alert(
          `Este teléfono ya se encuentra registrado en la base de datos`
        );
      }
      // 2 - Guardar el pre-user
      let objeto = {
        expediente: this.expedienteSelected.idx,
        ref: this.expedienteSelected.detalle.refCatastro,
        inmueble: item.car,
        preUserTlf: tlf
      };
      const encBtoA = window.btoa(JSON.stringify(objeto));
      const url = "https://usuarios.gestionayudas.es/register/phone/?token=";
      const token = `${url}${encBtoA}`;
      objeto.preUserName = nombre;
      objeto.token = token;
      this.$dbFB
        .ref("usersPrereg")
        .child(tlf)
        .set(objeto);
      // 3 - Actualizar el registro en catastro/inmueble
      this.$dbFB
        .ref("catastro")
        .child(result.ref)
        .child("inmuebles")
        .child(item.car)
        .update({
          preUserName: nombre,
          preUserTlf: tlf,
          preUserToken: token,
          preUserSaved: true
        });

      const index = this.catastroSelected.inmuebles.findIndex(
        caso => caso.car === item.car
      );
      // Enviar wathsapp
      let message = encodeURIComponent(`Hola ${nombre},
            Le escribimos desde gestionayudas.es, en virtud de acuerdo suscrito con su Comunidad de Propietarios, en relación a la tramitación de las subvenciones que estamos gestionando para usted y para su Comunidad de Propietarios.
            Para poder continuar con nuestro trabajo, necesitamos que acceda a nuestro sitio web y siga las instrucciones para realizar el proceso de alta y toma de datos.
            Por favor, haga click en el siguiente enlace para acceder:
            ${token}`);
      const lnk =
        "https://api.whatsapp.com/send?text=" +
        message +
        "&phone=" +
        encodeURIComponent(`34${tlf}`);

      this.$nextTick(() => {
        this.catastroSelected.inmuebles[index].preUserSaved = true;
        this.catastroSelected.inmuebles[index].preUserName =
          item.preUserName + " ";
        // Abre aplicación what
        window.open(lnk);
      });
    },
    userUid2Name(idx) {
      // Recibe el uid de un usuario y devuelve su nombre y apellidos o su email
      let result = false;
      if (this.users) {
        const user = this.users[idx];
        if (user) {
          result = user.admin.email;
          if (user.private) {
            const name = `${user.private.nombre} ${user.private.apellidos}`;
            if (name.length > 2) {
              result = name;
            }
          }
        }
      }
      return result;
    },
    formatNumber2Dec(n, d = 0) {
      if (!n) {
        return "-";
      }
      const number =
        typeof n === "string" ? parseFloat(n.replace(",", ".")) : n;
      const operando = Math.pow(10, d);
      return (
        "" + parseFloat(Math.round(number * operando) / operando).toFixed(d)
      );
    },
    removeExpteFilter(item, campo) {
      const idx = this.expedientesFilterOption[campo].indexOf(item);
      this.expedientesFilterOption[campo].splice(idx, 1);
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    asignarUserCatastro(refCatastro, car) {
      // consoleLog(`Asignar propietario al inmueble ${refCatastro}-${car}`)
      this.userSearchFor = {
        case: "userAsignCatastro",
        refCatastro: refCatastro,
        car: car
      };
      this.userAsignar = true;
      this.usersFilterOption.rol = ["Usuario"];
      this.usersFilteredList = true;
      this.bottomNav = 3;
    },
    userAsignation(user) {
      // consoleLog(`Asignar el usuario ${user} para ${this.userSearchFor.case}`)
      switch (this.userSearchFor.case) {
        case "userAsignCatastro":
          this.$dbFB
            .ref("catastro")
            .child(this.userSearchFor.refCatastro)
            .child("inmuebles")
            .child(this.userSearchFor.car)
            .child("propietario")
            .set(user);
          this.catastroCarga(this.userSearchFor.refCatastro);
          this.userSearchFor = false;
          this.userAsignar = false;
          this.usersFilterOption.rol = [];
          this.bottomNav = 1;
          break;
        default:
          break;
      }
    },
    expteEditUser(idx, categoria = "user") {
      // consoleLog(`Editar usuario: ${idx} como ${categoria}`)
      if (idx) {
        this.userEdit(idx);
      } else {
        // consoleLog(`Agregar nuevo usuario ${categoria}`)
      }
      return categoria;
    },
    expteId(idx) {
      if (idx) {
        if (idx.length > 10) {
          return `${idx.substr(0, 3)}...${idx.substr(-3, 3)}`;
        }
        return idx;
      }
      return idx;
    },
    clearSearchCatastro() {
      this.searchCatastro = "";
    },
    getResultCatastro() {
      // 1 - Buscar en la Base de datos

      // 2 - Buscar en el catastro
      let curl = "https://"; // Poner la url del API
      let searchUrl = curl + this.searchCatastro;
      this.$http
        .get(searchUrl, { crossdomain: true })
        .then(
          function(response) {
            this.searchingCatastro = "";
            let extraidos = this.extraeCatastroData(response.data);
            if (extraidos !== null) {
              this.catastroSave(extraidos, this.searchCatastro);
            }
          }.bind(this)
        )
        .catch(function(error) {
          return error;
          // consoleLog(error)
        });
    },
    extraeCatastroData(data) {
      // consoleLog(data)
      if (data === null) {
        // consoleLog('Error en la data. No existen datos')
        return null;
      }
      let parser = new DOMParser();
      let doc = parser.parseFromString(data, "application/xml");
      // let control = parseInt(doc.getElementsByTagName('control')[0].textContent.trim())
      let inmuebles = doc.getElementsByTagName("rcdnp");
      let campos = [
        ["car", "car"],
        ["cc1", "cc1"],
        ["cc2", "cc2"],
        ["bq", "dir_int_bloque"],
        ["es", "dir_int_escalera"],
        ["pt", "dir_int_planta"],
        ["pu", "dir_int_puerta"]
      ];
      let camposGlobal = [
        ["cp", "provinciaCode"],
        ["cm", "localidadCode"],
        ["cmc", "localidadCodeDGC"],
        ["np", "dir_provinciaName"],
        ["nm", "dir_localidadName"],
        ["nem", "dir_entidadMenorName"],
        ["cv", "viaCode"],
        ["tv", "dir_viaTipo"],
        ["nv", "dir_viaName"],
        ["pnp", "dir_viaNumber"],
        ["plp", "dir_viaLeter"],
        ["dp", "dir_cp"],
        ["dm", "dir_distrito"]
      ];
      let result = {
        expediente: this.expedienteSelected.idx,
        datos: {},
        inmuebles: []
      };
      for (let index = 0; index < inmuebles.length; index++) {
        const inmueble = inmuebles[index];
        let salida = {};
        for (let i = 0; i < campos.length; i++) {
          const campo = campos[i];
          const element = inmueble.getElementsByTagName(campo[0])[0];
          salida[campo[1]] = element ? element.textContent : "";
        }
        salida.propietario = "";
        if (index === 0) {
          for (let i = 0; i < camposGlobal.length; i++) {
            const campo = camposGlobal[i];
            const element = inmueble.getElementsByTagName(campo[0])[0];
            result.datos[campo[1]] = element ? element.textContent : "";
          }
        }
        result.inmuebles.push(salida);
      }
      // consoleLog(`Control: ${control}`)
      // consoleLog(`Número de inmuebles: ${inmuebles.length}`)
      return result;
    },
    uptdateExpediente() {
      this.guardando = true;
      this.updateExpediente({
        idx: this.expedienteSelected.idx,
        data: this.expedienteSelected.detalle
      });
      let ref = this.expedienteSelected.detalle.refCatastro;
      this.catastroCarga(ref);
      this.save();
      /* this.$dbFB.ref('expedientes').child(this.expedienteSelected.idx).update(this.expedienteSelected.detalle, () => {
                // consoleLog('Usuario Actualizado')
                let ref = this.expedienteSelected.detalle.refCatastro
                this.catastroCarga(ref)
                this.save()
            }) */
    },
    catastroSave(data, ref) {
      const inmuebles = data.inmuebles;
      delete data.inmuebles;
      this.$dbFB
        .ref("catastro")
        .child(ref)
        .set(data);
      const campos = [
        ["luso", "uso"],
        ["sfc", "superficie"],
        ["cpt", "participacion"],
        ["ant", "antiguedad"]
      ];
      const camposCons = [["lcd", "uso"], ["stl", "superficie"]];
      for (let index = 0; index < inmuebles.length; index++) {
        let salida = inmuebles[index];
        const refCatastro = ref + salida.car;
        const curl = "https://"; // definir la url API
        const searchUrl = curl + refCatastro;
        this.$http
          .get(searchUrl, { crossdomain: true })
          .then(
            function(response) {
              const parser = new DOMParser();
              const doc = parser.parseFromString(
                response.data,
                "application/xml"
              );
              // let salida = {}
              for (let i = 0; i < campos.length; i++) {
                const campo = campos[i];
                const element = doc.getElementsByTagName(campo[0])[0];
                salida[campo[1]] = element ? element.textContent : "";
              }
              salida.cons = [];
              const cons = doc.getElementsByTagName("cons");
              for (let c = 0; c < cons.length; c++) {
                const consC = cons[c];
                let salidaCons = {};
                for (let i = 0; i < camposCons.length; i++) {
                  const campoCons = camposCons[i];
                  const elementCons = consC.getElementsByTagName(
                    campoCons[0]
                  )[0];
                  salidaCons[campoCons[1]] = elementCons
                    ? elementCons.textContent
                    : "";
                }
                salida.cons.push(salidaCons);
              }
              this.$dbFB
                .ref("catastro")
                .child(ref)
                .child("inmuebles")
                .child(salida.car)
                .set(salida);
            }.bind(this)
          )
          .catch(function(error) {
            return error;
            // consoleLog(error)
          });
        if (index >= inmuebles.length - 1) {
          this.expedienteSelected.detalle.refCatastro = this.searchCatastro;
          this.expedienteSelected.detalle.provincia =
            data.datos.dir_provinciaName;
          this.uptdateExpediente();
        }
      }
    },
    expedienteSave() {
      // consoleLog('Guardar expediente')
      if (this.expedienteSelected) {
        this.guardando = true;
        const idx = this.expedienteSelected.idx;
        const data = this.expedienteSelected.detalle;
        this.$dbFB
          .ref("expedientes")
          .child(idx)
          .set(data, () => {
            // consoleLog(`Guardado el expediente ${idx}`)
            this.save();
          });
      }
    },
    catastroCarga(refCatastro) {
      // consoleLog(`Referencia Catastro: ${refCatastro}`)
      this.$dbFB
        .ref("catastro")
        .child(refCatastro)
        .once("value")
        .then(snapshot => {
          let val = snapshot.val();
          const inmuebles = val.inmuebles;
          if (Array.isArray(inmuebles)) {
            // Eliminar cuando terminen las pruebas
            this.catastroSelected = snapshot.val();
          } else {
            // versión definitiva
            // delete val.inmuebles
            let inmu = [];
            Object.keys(inmuebles).forEach(key => {
              let doc = inmuebles[key];
              if (!doc.preUserName && !doc.propietario) {
                (doc.preUserName = ""), (doc.preUserTlf = "");
              }
              inmu.push(doc);
            });
            val.inmuebles = inmu;
            this.catastroSelected = val;
          }
        })
        .catch(error => {
          // consoleLog(error)
          return error;
        });
    },
    direccionCatastro(data) {
      let result = false;
      if (data) {
        result = {
          direc1: `${data.dir_viaTipo} ${data.dir_viaName}, ${
            data.dir_viaNumber
          } ${data.dir_viaLeter}`.trim(),
          direc2: `${data.dir_cp} - ${data.dir_localidadName}, ${
            data.dir_provinciaName
          }`
        };
      }
      return result;
    },
    save() {
      this.userProfile.isEditing = false;
      this.userProfile.hasSaved = true;
      this.expedienteProfile.isEditing = false;
      this.expedienteProfile.hasSaved = true;
      this.guardando = false;
      this.closeDocument();
    }
  },
  computed: {
    ...mapGetters(["inmueblesForm", "propietariosForm"]),
    municipioSelect() {
      return this.$store.getters.getMunicipiosSelect;
    },
    provinciaSelect() {
      return this.$store.getters.getProvinciasSelect;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    usersPreReg() {
      return this.$store.getters.getUsersPreReg;
    },
    expteStatus() {
      return this.$store.getters.getExpedientesStatus;
    },
    expedientes() {
      return this.$store.getters.getExpedientesActivos;
    },
    uid() {
      return this.$store.getters.getUserUid;
    },
    usersFilterd() {
      let result = this.usuariosList;
      if (this.usersFilteredList) {
        if (this.usersFilterOption.rol.length > 0) {
          result = result.filter(
            item => this.usersFilterOption.rol.indexOf(item.rol) > -1
          );
        }
      }
      return result;
    },
    usersFiltersRol() {
      if (this.usuariosList) {
        return this.usuariosList.map(item => item.rol).filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    usersArray() {
      return this.$store.getters.getUsersArray;
    },
    adminfincasObject() {
      return this.$store.getters.getAdminFincasObject;
    },
    adminfincas() {
      return this.$store.getters.getAdminFincas; // getAdminFincas
    },
    gestoresObject() {
      return this.$store.getters.getGestoresObject;
    },
    gestores() {
      return this.$store.getters.getGestores;
    },
    catastroFilter() {
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      const uso = this.catastroFilterOption.uso;
      const propietario = this.catastroFilterOption.propietario;
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        if (result.length > 0 && propietario.length > 0) {
          const propi = propietario.map(item =>
            item.id ? item.id : "Sin Asignar"
          );
          result = result.filter(
            item =>
              (item.propietario === "" && propi.indexOf("Sin Asignar") > -1) ||
              propi.indexOf(item.propietario) > -1
          );
        }
      }
      return result;
    },
    catastroFilterPre() {
      // pre-registrar usuario
      let result = this.catastroSelected ? this.catastroSelected.inmuebles : [];
      result = result.filter(item => item.propietario === "");
      const uso = this.catastroFilterOption.uso;
      // const propietario = this.catastroControl.tableOption === 1 ? [{id:false}] : this.catastroFilterOption.propietario
      if (this.catastroFilteredList) {
        if (result.length > 0 && uso.length > 0) {
          result = result.filter(item => uso.indexOf(item.uso) > -1);
        }
        // if (result.length > 0 && propietario.length > 0) {
        // const propi = propietario.map(item => item.id ? item.id : 'Sin Asignar')
        // result = result.filter(item => (item.propietario === '' && propi.indexOf('Sin Asignar') > -1) || propi.indexOf(item.propietario) > -1)
        // }
      }
      return result;
    },
    inmueblesFiltersUso() {
      if (this.catastroSelected) {
        return this.catastroSelected.inmuebles
          .map(item => item.uso)
          .filter(this.onlyUnique);
      }
      return ["Sin resultados"];
    },
    inmueblesFiltersPropietarioNamed() {
      return this.inmueblesFiltersPropietario.map(item => {
        return {
          id: item !== "Sin Asignar" ? item : false,
          name: item !== "Sin Asignar" ? this.userUid2Name(item) : "Sin Asignar"
        };
      });
    },
    inmueblesFiltersPropietario() {
      if (this.catastroSelected) {
        const result = ["Sin Asignar"];
        const filter = this.catastroSelected.inmuebles
          .map(item => item.propietario)
          .filter(item => item.length > 0)
          .filter(this.onlyUnique);
        const salida = result.concat(filter);
        return salida;
      }
      return ["Sin resultados"];
    },
    expedientesFiltersAplicados() {
      let result = this.expedientesFilterOption.provincia.slice();
      result = result.concat(this.expedientesFilterOption.gestor.slice());
      result = result.concat(this.expedientesFilterOption.admon.slice());
      result = result.concat(this.expedientesFilterOption.status.slice());
      return this.expteFilteredList ? result : [];
    },
    expedientesFilterProvincias() {
      return this.expedientes
        .map(item => item.detalle.provincia)
        .filter(this.onlyUnique);
    },
    expedientesFilterGestor() {
      return this.expedientes
        .map(item => this.gestoresObject[item.detalle.gestor] || "Sin Gestor")
        .filter(this.onlyUnique);
    },
    expedientesFilterAdmon() {
      return this.expedientes
        .map(
          item =>
            this.adminfincasObject[item.detalle.admon] || "Sin Administrador"
        )
        .filter(this.onlyUnique);
    },
    expedientesFilterStatus() {
      return this.expedientes
        .map(item => item.detalle.status)
        .filter(this.onlyUnique);
    },
    expedientesFilter() {
      let result = this.expedientes;
      let provincias = this.expedientesFilterOption.provincia;
      let gestores = this.expedientesFilterOption.gestor;
      let admones = this.expedientesFilterOption.admon;
      let status = this.expedientesFilterOption.status;
      if (this.expteFilteredList) {
        if (provincias.length > 0) {
          result = result.filter(
            item => provincias.indexOf(item.detalle.provincia) > -1
          );
        }
        if (gestores.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.gestor && gestores.indexOf("Sin Gestor") > -1) ||
              gestores.indexOf(this.gestoresObject[item.detalle.gestor]) > -1
          );
        }
        if (admones.length > 0) {
          result = result.filter(
            item =>
              (!item.detalle.admon &&
                admones.indexOf("Sin Administrador") > -1) ||
              admones.indexOf(this.adminfincasObject[item.detalle.admon]) > -1
          );
        }
        if (status.length > 0) {
          result = result.filter(
            item => status.indexOf(item.detalle.status) > -1
          );
        }
      }
      return result;
    },
    usuariosList() {
      return this.$store.getters.getUsersList;
    },
    userChange() {
      return this.usuario.notas === this.originalUser.notas;
    },
    color() {
      switch (this.bottomNav) {
        case 0:
          return "blue lighten-1";
        case 1:
          return "teal";
        case 2:
          return "brown";
        case 3:
          return "red";
        case 4:
          return "blue-grey";
        default:
          return "green";
      }
    }
  }
};
</script>
